<template>
  <div>        
    <div v-if="!isLoading">
      <div class="greybox">
        <input class="" type="search" placeholder="Find claim by reference" aria-label="Search" v-model="quickSearch">
        <button class="button" type="submit" @click="handleFindClick">
          Find
        </button>
        &nbsp;
        <button class="button" type="cancel" @click="handleResetClick">
          Reset
        </button>
      </div>
      <hr />

      <div class="greybox">
        <span v-if="totalRecords == 0">
            <p>You currently have no gadgets that require a repair option to be selected.</p>
        </span>

        <div v-if="totalRecords != 0 && !viewAllClaims && claimsList.length > 0">
          <h2>Your most recent claim...</h2>
          <div class="claim-list-card mt-2 mb-2">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  
                  <div class="row">
                    <div class="col-sm-4">
                      <p><strong>Claim reference</strong></p>
                    </div>
                    <div class="col-sm-8 repair-options-data-col">
                      <p>{{claimsList[0].claimReference}}</p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-sm-4">
                      <p><strong>Gadgets</strong></p>
                    </div>
                    <div class="col-sm-8 repair-options-data-col">
                      <div v-for="(gadget, index) in claimsList[0].gadgets" :key="index">
                        <div v-if="gadget.repairOption">
                          <p>{{gadget.displayName}} {{gadget.repairOption.displayName}}</p>
                          <button v-if="gadget.repairOption.allowCancel" class="button-small mr-2 mb-2" @click="cancelRepairOption(claimsList[0], gadget)">
                            Cancel option
                          </button>
                        </div>
                        <div v-else>
                          <p>{{gadget.displayName}}</p>
                          <button class="button-small mb-2" @click="showRepairOptionsEx(claimsList[0], gadget)">
                            Select an option
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                
                </div>
                <div class="col-md-4">
                  <p class="float-right" :class="[statusTextColour(claimsList[0])]"><strong>{{claimsList[0].status}}</strong></p>
                </div>
              </div>
            </div>
          </div>
          <button class="button" @click="handleViewAllClick()">
            View all claims
          </button>
        </div>
        <div v-if="viewAllClaims">
          <div v-for="(claim, index) in claimsList" :key="'claimList_' + index" class="claim-list-card mb-2">
            <div class="card-body repair-option-card-body">
              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col-sm-4">
                      <p><strong>Claim reference</strong></p>
                    </div>
                    <div class="col-sm-8 repair-options-data-col">
                      <p>{{claim.claimReference}}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <p><strong>Gadgets</strong></p>
                    </div>
                    <div class="col-sm-8 repair-options-data-col">
                      <div v-for="(gadget, index) in claim.gadgets" :key="index">
                        <div v-if="gadget.repairOption">
                          <p>{{gadget.displayName}} {{gadget.repairOption.displayName}}</p>
                          <button v-if="gadget.repairOption.allowCancel" class="button-small mr-2 mb-2" @click="cancelRepairOption(claimsList[0], gadget)">
                            Cancel option
                          </button>
                        </div>
                        <div v-else>
                          <p>{{gadget.displayName}}</p>
                          <button class="button-small mb-2" @click="showRepairOptionsEx(claimsList[0], gadget)">
                            Select an option
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                    <p class="float-right" :class="[statusTextColour(claim)]"><strong>{{claim.status}}</strong></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <br />
      
      <b-pagination v-if="(totalRecords > perPage) && viewAllClaims"
                    align="right"
                    size="md"
                    :total-rows="totalRecords"
                    v-model="currentPage"
                    :per-page="perPage"
                    @input="handlePagenationInput">
      </b-pagination>
    </div>
    <div v-else>
        <span>Loading...</span>
    </div>

    <!-- <repair-options-modal ref="repairOptionsModal1" :key="'repairOptionsModal1'" :selectedClaim="{}" :gadget="{}" @hidden="handleRepairOptionModalHidden()"> </repair-options-modal> -->

    <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"></loading>
  </div>
</template>

<script>

import { mapActions } from 'vuex'

// import repairOptionsModal from '@/components/RepairOptionsModal.vue'

import loading from 'vue-loading-overlay'

export default {
  name: 'repairOptions',
  components: {
    loading,
    // repairOptionsModal
  },
  data: () => {
    return {
      currentPage: 0,
      perPage: 5,
      includeAll: false,
      quickSearch: '',
      viewAllClaims: false
    }
  },
  mounted () {
    this.load({ includeAll: this.includeAll })
  },
  watch: {
    
  },
  computed: {
    isLoading () {
      return this.$store.state.myclaims.loading
    },
    claimsList () {
      return this.$store.state.myclaims.claimsList
    },
    selectedClaim: {
      get () {
        return this.$store.state.myclaims.selectedClaim
      },
      set (value) {
        this.$store.commit('myclaims/setSelectedClaim', value)
      }
    },
    selectedClaimGadgets () {
      if (this.selectedClaim) {
        return this.selectedClaim.gadgets
      }
      return null
    },
    pageSize () {
      return this.$store.state.myclaims.pagenation.pageSize
    },
    totalRecords () {
      if (this.$store.state.myclaims.pagenation) {
        return this.$store.state.myclaims.pagenation.totalRecords
      } else {
        return 0
      }
    },
    mostRecentClaim () {
      return this.claimsList[0]
    },
    mostRecentClaimFirstGadget () {
      return this.mostRecentClaim.gadgets[0]
    }
  },
  methods: {
    ...mapActions({
      load: 'myclaims/getClaimsList',
      setGadget: 'myclaims/setSelectedGadget'
    }),
    statusTextColour (claim) {
      if (claim) {
        if (claim.status == 'DECLINED') { return 'text-danger' }

        if (claim.status == 'APPROVED') { return 'text-success' }

        if (claim.status == 'UNDER REVIEW') { return 'text-warning' }
      }

      return ''
    },
    showRepairOptionsEx (claim, gadget) {
      this.selectedClaim = claim
      // this.showRepairOptions(gadget)
      this.setGadget(gadget)
      this.$router.push({ path: '/myclaims/repairoptions/list' })
    },
    cancelRepairOption (claim, gadget) {
      this.selectedClaim = claim
      this.setGadget(gadget)
      this.$router.push({ path: '/myclaims/repairoptions/cancel' })
    },
    // showRepairOptions (gadget) {
    //   this.$refs.repairOptionsModal1.selectedClaim = this.selectedClaim
    //   this.$refs.repairOptionsModal1.gadget = gadget
    //   this.$refs.repairOptionsModal1.show()
    // },
    // showRepairOptionsForMostRecent () {
    //   this.$refs.repairOptionsModal1.selectedClaim = this.mostRecentClaim
    //   this.$refs.repairOptionsModal1.gadget = this.mostRecentClaimFirstGadget
    //   this.$refs.repairOptionsModal1.show()
    // },
    // handleRepairOptionModalHidden () {
    //   this.load(
    //     {
    //       pageNumber: 1,
    //       pageSize: this.pageSize,
    //       includeAll: this.includeAll,
    //       quickSearch: this.quickSearch
    //     })
    // },
    handlePagenationInput (payload) {
      this.load(
        {
          pageNumber: payload,
          pageSize: this.pageSize,
          includeAll: this.includeAll,
          quickSearch: this.quickSearch
        })
    },
    handleViewAllClick () {
      this.viewAllClaims = true
    },
    handleFindClick () {
      this.load(
        {
          pageSize: this.pageSize,
          includeAll: this.includeAll,
          quickSearch: this.quickSearch
        })
    },
    handleResetClick () {
      this.quickSearch = ''
      this.load(
        {
          pageSize: this.pageSize,
          includeAll: this.includeAll,
          quickSearch: this.quickSearch
        })
    }
  }
}
</script>

